import { React, useState } from "react";
import Button from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";

import {
  Star,
  Smartphone,
  Globe,
  Zap,
  ArrowRight,
  MapPin,
  CheckCircle,
  CreditCard,
  Package,
  ChevronLeft,
  ChevronRight,
  UserPlus,
  Settings,
  Upload,
  Calculator,
  Menu,
  X,
  Printer,
  Monitor,
  Heart,
  Mail,
  PhoneCall,
  ArrowLeft,
} from "lucide-react";
import { Image } from "antd";
import { routes } from "../../Routes";
import { useNavigate } from "react-router";
import { RoughNotation } from "react-rough-notation";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/language-switcher";
import { store } from "../../Redux/store";
import LandingSubs from "./LandingSubs";
import { LeadFormComp } from "./LeadFormComp";
import { getUTMs } from "../../Utils/utm";


const Footer = () => {

  const { i18n, t } = useTranslation()
  const [modalTitle, setModalTitle] = useState(t("Talk to Sales"));
  const [showModal, setShowModal] = useState(false);



  const openContactUsModal = () => {
    setModalTitle(t("Contact Us"));
    setShowModal(true);
  };
  const openTalkToSalesModal = () => {
    setModalTitle(t("Talk to Sales"));
    setShowModal(true);
  };

  return (
    <footer className="bg-card border-t border-border py-12 ">
      <div className="mx-auto w-full max-w-[1200px] px-4">
        <div className="grid md:[grid-template-columns:1.5fr_1fr_1fr_1fr] gap-7 ">
          <div className="space-y-1 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2 mb-3">
              <Image
                src="https://hisabak.com/static/media/hisabakLogo.35953b144495459dcc84.png"
                alt="myGINNE logo"
                width={140}
                height={38}
                preview={false}
              />
            </div>
            <div
              className={`text-[12px] mb-1 ${i18n.language === "ar" ? "text-right" : "text-left"
                }`}
              dir="ltr"
            >
              myGINNE Digityal,<span > </span>
              {t(
                "14 Prince Waleed Bin-Thinyan Al-Saud, Sheraton Al Matar, El Nozha, Cairo Governorate 11799",
              )}
            </div>

            <div
              className={`flex items-center text-[12px] mb-1 ${i18n.language === "ar" ? "justify-end" : "justify-start"
                }`}
              dir="ltr"
            >
              <PhoneCall
                className={`${i18n.language === "ar" ? "mr-2" : "mr-2"
                  } w-4 h-4 text-primary`}
              />
              +20 100 450 5666
            </div>

            <div
              className={`flex items-center text-[12px] mb-1 ${i18n.language === "ar" ? "justify-end" : "justify-start"
                }`}
              dir="ltr"
            >
              <Mail
                className={`${i18n.language === "ar" ? "mr-2" : "mr-2"
                  } w-4 h-4 text-primary`}
              />
              support@myginne.com
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-foreground">
              {t("Company")}
            </h4>
            <div className="space-y-2 text-muted-foreground">
              <p>
                <a
                  href="/aboutus"
                  className="hover:text-primary transition-colors"
                  target="blank"
                >
                  {t("About Us")}
                </a>
              </p>
              <p>
                <a
                  href="https://myginne.com/privacy-policy.html"
                  className="hover:text-primary transition-colors"
                  target="blank"
                >
                  {t("Privacy Policy")}
                </a>
              </p>
              <p>
                <a
                  href="https://myginne.com/refund-and-cancellation-policy"
                  target="blank"
                  className="hover:text-primary transition-colors"
                >
                  {t("Refund & Cancellation Policy")}
                </a>
              </p>
              <p>
                <a
                  href="https://myginne.com/shipping-and-delivery-policy"
                  target="blank"
                  className="hover:text-primary transition-colors"
                >
                  {t("Shipping & Delivery Policy")}
                </a>
              </p>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-foreground">
              {t("Support")}
            </h4>
            <div className="space-y-2 text-muted-foreground">
              <p>
                <a
                  href="https://api.whatsapp.com/send/?phone=201004505666&text&type=phone_number&app_absent=0"
                  className="hover:text-primary transition-colors"
                  target="blank"
                >
                  {t("WhatsApp Support")}
                </a>
              </p>
              <p>

              </p>
              {/* <p>
                  <a href="#" className="hover:text-primary transition-colors">
                    {t("Training Videos")}
                  </a>
                </p> */}
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-foreground">
              {t("Download Apps")}
            </h4>
            <div className="space-y-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.myginne.com.storeapp&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <Button
                  variant="new"
                  className="w-full justify-start border-none"
                >
                  {/* <Smartphone className="mr-2 w-4 h-4" /> */}
                  <Image
                    src={require("../../assets/Logo/hisabakstore.webp")}
                    alt="myGINNE logo"
                    width={37}
                    height={37}
                    preview={false}
                    style={{ borderRadius: "8px" }}
                  />
                  {t("Hisabak App")}
                </Button>
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.myginne.app&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <Button
                  variant="new"
                  className="w-full justify-start border-none"
                >
                  {/* <Smartphone className="mr-2 w-4 h-4" /> */}
                  <Image
                    src={require("../../assets/Logo/hisabakpos.webp")}
                    alt="myGINNE logo"
                    width={37}
                    height={37}
                    preview={false}
                    style={{ borderRadius: "8px" }}
                  />
                  {t("Hisabak POS")}
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8 mt-8 text-center text-muted-foreground ">
          <a href="https://www.myginne.com">
            {t(
              "© 2026 myGINNE. All rights reserved. Made for Egyptian retailers with ❤️",
            )}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;